import { createFileRoute } from '@tanstack/react-router';
import { SHEET_TABS } from '@/features/sync/sheetTabConfigs';
import { SyncHistoryPage } from '@/features/sync/SyncHistoryPage';

export const Route = createFileRoute('/_authenticated/attendance/sync/')({
  component: () => <SyncHistoryPage config={SHEET_TABS.attendance} />,
});
